import { render, staticRenderFns } from "./ComplaintForm.vue?vue&type=template&id=5fbfbcb4&scoped=true"
import script from "./ComplaintForm.vue?vue&type=script&lang=js"
export * from "./ComplaintForm.vue?vue&type=script&lang=js"
import style0 from "./ComplaintForm.vue?vue&type=style&index=0&id=5fbfbcb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbfbcb4",
  null
  
)

export default component.exports